import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Homepage from "./pages/Homepage";
import ListingPage from "./pages/ListingPage";
import ShowPage from "./pages/ShowPage";
import MainLayout from "./layouts/MainLayout";
import AboutUsPage from "./pages/AboutUsPage";
import CountriesPage from "./pages/CountriesPage";
import BlogPage from "./pages/BlogPage";
import ContactAgentsPage from "./pages/ContactAgentsPage";
import ContactUsPage from "./pages/ContactUsPage";
import BlogShowPage from "./pages/BlogShowPage";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
       <Route path="/web" element={<MainLayout />}>
          <Route index element={<Homepage />} />
          <Route path="/web/listing" element={<ListingPage />} />
          <Route path="/web/itinerary/:id" element={<ShowPage />} />
          <Route path="/web/about-us" element={<AboutUsPage />} />
          <Route path="/web/countries" element={<CountriesPage />} />
          <Route path="/web/blog" element={<BlogPage />} />
          <Route path="/web/blog/:id" element={<BlogShowPage />} />
          <Route path="/web/contact-agents" element={<ContactAgentsPage />} />
          <Route path="/web/contact-us" element={<ContactUsPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}